import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from './translate.service';
@Injectable({
  providedIn: 'root'
})
export class AlertsService {

  constructor(
    private toastr: ToastrService,
    private translateService: TranslateService
  ) {
  }
  public success(message: string, title?: string, is_custom?: boolean) {
    if(is_custom != null && is_custom == true){
      return this.toastr.success("", message);
    } else
      return this.toastr.success("", "Request Successful");
    //return this.toastr.success(title || 'Success', message);
  }
  public error(message: string, title?: string) {
    this.translateService.translate(message).subscribe(x => {
      if (x) {
        this.toastr.error("", x, { timeOut: 15000 });
      } else {
        this.toastr.error("", message, { timeOut: 15000 });
      }
    });

    //return this.toastr.error(title || 'Failed', message);
  }
  public alert(message: string, title?: string) {
    this.translateService.translate(message).subscribe(x => {
      if (x) {
        this.toastr.warning("", x);
      } else {
        this.toastr.warning("", message);
      }
    });
  }
  public info(message: string, title?: string, timer?: number) {
    this.translateService.translate(message).subscribe(x => {
      if (x) {
        if(timer)
          this.toastr.info("", x, { timeOut: timer });
        else
        this.toastr.info("", x);
      } else {
        if(timer)
          this.toastr.info("", message, { timeOut: timer });
        else
        this.toastr.info("", message);
      }
    });
    // return this.toastr.info(title || 'Info', message);
  }
  public successWithMessage(title, message: string) {
    this.translateService.translate(message).subscribe(x => {
      if (x) {
        this.toastr.success("", x);
      } else {
        this.toastr.success("", message);
      }
    });
    //return this.toastr.success(title || 'Success', message);
  }
}
